import { HttpClient, HttpContext, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService, PROJECT_CONTEXT_TOKEN } from '@cosmos/angular/utils';
import { Device } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  findLoraGateways(query=''): Observable<HttpResponse<Device[]>> {
    return this.http
      .get<Device[]>(`${environment.API_URL}/devices/loragateways/chirp${query}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  findGateways(query=''): Observable<HttpResponse<Device[]>> {
    return this.http
      .get<Device[]>(`${environment.API_URL}/devices/gateways/status${query}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        ); 
  }

  find(query=''): Observable<HttpResponse<Device[]>> {
    return this.http
      .get<Device[]>(`${environment.API_URL}/devices${query}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  findById(id: string, query = ''): Observable<HttpResponse<Device>> {
    return this.http
      .get<Device>(`${environment.API_URL}/devices/${id}${query}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  create(body: Device, projectId?: string) {
    const context = projectId ? new HttpContext().set(PROJECT_CONTEXT_TOKEN, projectId) : undefined;
    return this.http
      .post(`${environment.API_URL}/devices`, body, {observe: 'response', context})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  update(body: any, projectId?: string) {
    const context = projectId ? new HttpContext().set(PROJECT_CONTEXT_TOKEN, projectId) : undefined;
    return this.http
      .patch(`${environment.API_URL}/devices/${body[0]}`, body[1], {observe: 'response', context})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

  delete(id: string) {
    return this.http
      .delete(`${environment.API_URL}/devices/${id}`, {observe: 'response'})
      .pipe(
        map(response => {return response;}),
        catchError( (error) =>{this.errorService.handleError(error); throw error;})
      );
  }

}
